import i18next from 'i18next';
import { SmsStatuses } from 'infrastructure/enums';

export interface ISmsStatusItem {
  id: SmsStatuses | null;
  name: string;
}

interface IProps {
  withAll?: boolean;
}

export const smsStatusesDataSource = (props?: IProps): ISmsStatusItem[] => {
  const { withAll = false } = props ?? {};

  const dataSource: ISmsStatusItem[] = [
    {
      id: SmsStatuses.Failed,
      name: i18next.t('smsStatuses.failed'),
    },
    {
      id: SmsStatuses.Received,
      name: i18next.t('smsStatuses.received'),
    },
    {
      id: SmsStatuses.Queued,
      name: i18next.t('smsStatuses.queued'),
    },
    {
      id: SmsStatuses.Delivered,
      name: i18next.t('smsStatuses.delivered'),
    },
    {
      id: SmsStatuses.Undelivered,
      name: i18next.t('smsStatuses.undelivered'),
    },
    {
      id: SmsStatuses.Sent,
      name: i18next.t('smsStatuses.sent'),
    },
  ];

  if (withAll) {
    dataSource.unshift({
      id: null,
      name: i18next.t('controls.all'),
    });
  }

  return dataSource;
};
